import { render, staticRenderFns } from "./toTop.vue?vue&type=template&id=0f2360f2&scoped=true&"
import script from "./toTop.vue?vue&type=script&lang=js&"
export * from "./toTop.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f2360f2",
  null
  
)

export default component.exports